"use client";

import { TextField, MenuItem } from "@mui/material";
import { useEditDialog } from "../Providers/EditDialogContext";
import { CampaignType, EmailCadence } from "@/interfaces/campaign";

export default function CampaignFields() {
  const {
    campaignType,
    campaignName,
    setCampaignName,
    emailCadence,
    setEmailCadence,
  } = useEditDialog();

  // Default to Video if campaign type is not available
  const type = campaignType || CampaignType.Video;

  return (
    <>
      <TextField
        label="Campaign Name"
        name="name"
        required
        value={campaignName}
        onChange={(event) => setCampaignName(event.target.value)}
        fullWidth
      />
      <input type="hidden" name="type" value={type} />
      <TextField
        name="frequency"
        label="How often would you like email notifications?"
        value={emailCadence}
        onChange={(event) => {
          setEmailCadence(event.target.value as EmailCadence);
        }}
        required
        select
        fullWidth
      >
        <MenuItem value={EmailCadence.Unsubscribed}>Unsubscribed</MenuItem>
        <MenuItem value={EmailCadence.Daily}>Daily</MenuItem>
        <MenuItem value={EmailCadence.Weekly}>Weekly</MenuItem>
      </TextField>
    </>
  );
}
